module.exports = __webpack_public_path__ + "res/img/avatar_female.2ae455a1.png";